/*global chrome*/
import React, { Component } from "react";
import { connect } from "react-redux";
import $ from "jquery";
import newImage from "../../../../../images/new.png";
import info from "../../../../../images/info.png";
import thumb from "../../../../../images/thumb.png";

import {
  getHelperTask,
  approveDraftSkill,
  getSession,
  executeFlow,
  updateDraftSkill,
  updateFormatedData,
  getDraftSkillsById,
} from "../../../../../redux/actions/skill";
import Loader from "../../../../../components/loader";
import EmptyLoader from "../../../../../components/emptyLoader";
import InfiniteScroll from "react-infinite-scroll-component";
import { notify } from "../../../../../redux/actions/snack";
import { withRouter } from "react-router";
import { compose } from "redux";
import { Tooltip } from "antd";

const TEMPLATE_WITH_LOOP_RESTRICTION = [
  "UserDocumentation",
  "In-App Walkthrough",
  "UserOnboarding",
  "Desktop Walkthrough",
];

const CATEGORIES = {
  "Data and Analytics": [
    "Data Management",
    "Data Integration",
    "Data Analysis"
  ],
  "Finance and Accounting": [
    "Financial Planning and Analysis",
    "Budgeting and Forecasting",
    "Accounts Payable / Receivable",
    "General Ledger / Bookkeeping",
    "Tax and Compliance",
    "Treasury and Cash Management",
    "Audit and Internal Controls"
  ],
  "Human Resources (HR)": [
    "Recruitment and Staffing",
    "Payroll and Benefits",
    "Employee Engagement",
    "Performance Management",
    "Learning and Development",
    "Diversity, Equity and Inclusion (DEI)",
    "HR Operations"
  ],
  "Legal and Compliance": [
    "Contract Management",
    "Regulatory Compliance",
    "Intellectual Property",
    "Corporate Policies",
    "Litigation Management"
  ],
  "Information Technology (IT)": [
    "IT Infrastructure",
    "Cybersecurity",
    "Application Development and QA",
    "IT Support / Helpdesk",
    "Cloud Services"
  ],
  "Marketing": [
    "Branding",
    "Advertising",
    "Digital Marketing",
    "Public Relations (PR)",
    "Product Marketing",
    "Market Research",
    "Social Media"
  ],
  "Sales": [
    "B2B / B2C Sales",
    "Lead Generation",
    "Sales Operations",
    "Key Account Management",
    "Channel Sales"
  ],
  "Operations": [
    "Process Management",
    "Procurement / Sourcing",
    "Supply Chain Management",
    "Vendor Management",
    "Inventory amd Logistics"
  ],
  "Product Management": [
    "Product Strategy",
    "Product Development",
    "User Research",
    "Roadmapping",
    "Innovation Management"
  ],
  "Customer Success and Support": [
    "Onboarding",
    "Technical Support",
    "Customer Relationship Management",
    "Renewals and Upsells",
    "Feedback and Improvement Loops"
  ],
  "Banking": [
    "Retail and Commercial Banking Operations",
    "Loan Origination and Servicing",
    "Trade Finance Operations",
    "Treasury Operations",
    "Wealth and Private Banking Services",
    "KYC / AML / Fraud Detection",
    "Core Banking Operations",
    "Risk and Credit Underwriting",
    "Regulatory Reporting (Basel, etc.)"
  ],
  "Insurance": [
    "Policy Underwriting and Issuance",
    "Claims Management",
    "Premium Billing and Collection",
    "Actuarial Analysis",
    "Reinsurance Operations",
    "Risk Assessment and Pricing",
    "Loss Adjustment and Settlement",
    "Regulatory Filings (e.g., NAIC)"
  ],
  "Healthcare (Providers and Hospitals)": [
    "Patient Registration and Scheduling",
    "Clinical Operations (OPD/IPD)",
    "Electronic Health Records (EHR) Management",
    "Medical Coding and Billing",
    "Revenue Cycle Management (RCM)",
    "Care Coordination",
    "Pharmacy Management",
    "Utilization Review and Case Management",
    "Diagnostic Lab Services"
  ],
  "Manufacturing": [
    "Production Planning and Control",
    "Plant Operations",
    "Quality Assurance and Testing",
    "Shop Floor Management",
    "Maintenance, Repair and Overhaul (MRO)",
    "Industrial Engineering",
    "Materials Requirement Planning (MRP)",
    "Manufacturing Execution System (MES)"
  ],
  "Pharmaceuticals": [
    "Clinical Trials Management",
    "Regulatory Submissions and Compliance (FDA, EMA)",
    "Pharmacovigilance (Drug Safety Monitoring)",
    "Formulation and Development",
    "Drug Manufacturing and QA/QC",
    "Medical Affairs",
    "Labeling and Packaging Compliance",
    "Good Manufacturing Practice (GMP) Audits"
  ],
  "Consumer Goods (FMCG)": [
    "Brand and Category Management",
    "Demand Planning and Forecasting",
    "Trade Promotions Management",
    "Product Lifecycle Management",
    "Consumer Insights and Surveys",
    "Merchandising and Retail Activation"
  ],
  "Retail": [
    "Store Operations and Management",
    "Merchandising and Assortment Planning",
    "Inventory Replenishment",
    "Point-of-Sale (POS) Operations",
    "Omnichannel Fulfillment (Click and Collect, etc.)",
    "Category and Shelf Management",
    "Returns and Reverse Logistics"
  ],
  "Hospitality (Hotels, Travel)": [
    "Front Office and Concierge Services",
    "Room Reservations and Housekeeping",
    "Food and Beverage Operations",
    "Events and Banquet Management",
    "Guest Services and Loyalty Programs",
    "Facility and Spa Management",
    "Travel Desk / Tour Operations"
  ],
  "Higher Education": [
    "Admissions and Enrollment Management",
    "Course Scheduling and Timetabling",
    "Student Records and Transcripts",
    "Curriculum Design and Accreditation",
    "Research Grants and Scholarly Publications",
    "Alumni Relations",
    "Student Financial Aid and Scholarships"
  ],
  "Hi-Tech / Software and SaaS": [
    "Software Development Lifecycle (SDLC)",
    "Product Release Management",
    "DevOps and CI/CD Operations",
    "Customer Onboarding and Support",
    "Licensing and Subscription Billing",
    "Technical Account Management",
    "Data and Cloud Infrastructure Operations"
  ],
  "Government / Public Sector": [
    "Citizen Services Delivery",
    "Public Policy Implementation",
    "Grant and Subsidy Management",
    "Government Procurement and Tenders",
    "Regulatory Oversight and Compliance",
    "Welfare and Social Program Administration",
    "Public Safety and Emergency Services"
  ]
};



class ApproveHelper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isLoadingApprove: false,
      isLoadingReject: false,
      helperTask: [],
      page: 1,
      pageInfo: [],
      hasMore: true,
      isScrolling: false,
      checked_task: [],
      category: "",
      subcategory: "",
      selectedValues: {},
      categories: { ...CATEGORIES }
    };
  }


  componentDidMount() {
    this.initializePopover();
  }

  componentWillMount() {
    this.props.getSession();
    this.getTask();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.page !== this.state.page) {
      this.getTask();
    }
    this.initializePopover();
  }

  initializePopover() {
    window.$('[data-toggle="popover"]').popover({
      container: 'body',
    });
  }
  getTask = async () => {
    const taskList = await this.props.getHelperTask(this.state.page);

    if (taskList && taskList.results) {
      this.setState({
        helperTask: this.state.helperTask.concat(taskList.results),
        pageInfo: taskList.results,
        isLoading: false,
        isScrolling: false,
      });
    } else {
      this.setState({
        isLoading: false,
        isScrolling: false,
        hasMore: false,
      });
    }
  };
  fetchData() {
    this.setState({ isScrolling: true });
    try {
      if (this.state.pageInfo.length < 14) {
        this.setState({
          hasMore: false,
        });
      } else {
        this.setState({
          page: this.state.page + 1,
        });
      }
    } catch (err) {
      this.setState({
        hasMore: false,
      });
      this.props.notify("error", "Failed to refresh");
    }
  }

  handleCheck = (e, task) => {
    // console.log("event: ", e.target.checked);
    if (e.target.checked) {
      let checked = [...this.state.checked_task, task.id];
      this.setState({ checked_task: checked });
    }
  };

  approveHelperTask = async () => {
    this.setState({ isLoadingApprove: true });

    try {
      const tasksToApprove = this.state.helperTask.filter(task => 
        this.state.checked_task.includes(task.id)
      );
      console.log("tasksToApprove: ", tasksToApprove);

      const invalidTasks = tasksToApprove.filter(task => 
        !task.CATEGORY || !task.subCategory
      );
      console.log("invalidTasks: ", invalidTasks);
      if (invalidTasks.length > 0) {
        this.props.notify(
          "error",
          "Please select both category and subcategory for all tasks before approving"
        );
        this.setState({ isLoadingApprove: false });
        return;
      }

      const response = await this.props.approveDraftSkill(
        this.state.checked_task,
        "approved"
      );
      if (response) {
        this.props.notify(
          "success",
          `${this.state.checked_task.length +
          "" +""+
          "Agent approved."
          }`
        );

        this.setState({ checked_task: [], isLoadingApprove: false });
        this.props.history.push(window.location.pathname);
      }
    } catch (err) {
      console.log("approve error");
      this.setState({ isLoadingApprove: false });
    }
  };

  rejectHelperTask = async () => {
    this.setState({ isLoadingReject: true });
    try {
      const response = await this.props.approveDraftSkill(
        this.state.checked_task,
        "declined"
      );
      if (response) {
        this.setState({ checked_task: [], isLoadingReject: false });
        this.props.notify("success", "Helper Rejected");
        this.props.history.push(window.location.pathname);
      }
    } catch (err) {
      console.log("reject error");
    }
  };

  modalPopUp = (data) => {
    this.setState({ popUpQuestion: data });
  };

  playSkill = async (item) => {
    var data = {
      deviceId: this.props.skill.draftSession,
      skillId: item.id,
      bulk: !TEMPLATE_WITH_LOOP_RESTRICTION.includes(item?.TEMPLATE),
    };
    if (data.deviceId === undefined) {
      this.props.notify(
        "error",
        "You are not connected to Super Assistant. Please install Super Assistant app."
      );
    } else {
      const playSkill = await this.props.executeFlow(data);
      if (playSkill.data.status == false) {
        chrome.runtime.sendMessage(
          process.env.REACT_APP_CHROME_TAB_ID,
          { type: "openLogin" },
          (response) => {
            if (response) {
              console.log("Extension Response", response);
            }
          }
        );
      }
    }
  };

  handleCategoryChange = (e, taskId) => {
    let helper_task = [...this.state.helperTask];
    const taskIndex = helper_task.findIndex(task => task.id === taskId);
    
    if (taskIndex !== -1) {
      helper_task[taskIndex].CATEGORY = e.target.value;
      helper_task[taskIndex].subCategory = ""; // Reset subcategory when category changes
      
      this.setState({ 
        helper_task,
        selectedValues: {
          ...this.state.selectedValues,
          [taskId]: {
            category: e.target.value,
            subcategory: ""
          }
        }
      });
    }
  };

  handleSubcategoryChange = (e, taskId) => {
    let helper_task = [...this.state.helperTask];
    const taskIndex = helper_task.findIndex(task => task.id === taskId);
    
    if (taskIndex !== -1) {
      helper_task[taskIndex].subCategory = e.target.value;
      
      this.setState({ 
        helper_task,
        selectedValues: {
          ...this.state.selectedValues,
          [taskId]: {
            ...this.state.selectedValues[taskId],
            subcategory: e.target.value
          }
        }
      });
    }
  };

  updateCategory = async (task) => {
    const skillDetails = await this.props.getDraftSkillsById(task.id);
    let skillData = skillDetails?.data?.data;
    const updateCatPayload = { 
      itemId: skillData.id, 
      CATEGORY: task.CATEGORY,
      subCategory: task.subCategory 
    };
    const updateHelper = await this.props.updateFormatedData(updateCatPayload);
    if (updateHelper) {
      this.props.notify("success", "Updated Successfully!");
    }
  };

  removeHtmlTags = (html) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  };
  
 

  render() {
    let { isLoadingApprove, isLoadingReject, helperTask } = this.state;
    
    return (
      <div className="fw-screen">
        <div
          className={
            this.props.minMode ? "right-content rm-margin" : "right-content"
          }
        >
          <div className="task-col">
            <div className="title-btn">
              <h1 className="title">My Tasks</h1>
              <div className="btn-flex-ra">
                <button
                  disabled={this.state.checked_task.length > 0 ? false : true}
                  className="btn btn-danger"
                  onClick={this.rejectHelperTask}
                >
                  {isLoadingReject ? (
                    <div class="sp sp-circle"></div>
                  ) : (
                    "Reject"
                  )}
                </button>
                <button
                  disabled={this.state.checked_task.length > 0 ? false : true}
                  className="btn btn-approve"
                  onClick={this.approveHelperTask}
                >
                  {isLoadingApprove ? (
                    <div class="sp sp-circle"></div>
                  ) : (
                    "Approve"
                  )}
                </button>
              </div>
            </div>
            {/* <ul className="nav nav-pills task-pills">
              <li className="active">
                <a data-toggle="pill" href="#waiting">
                  <div className="tlc-title">
                    <span className="tlc-icon">
                      <img
                        src={newImage}
                        alt=""
                        style={{ marginLeft: "10px", width: "28px" }}
                      />
                    </span>
                    <p>Skills</p>
                  </div>
                </a>
              </li>
            </ul> */}
            <div
              id="scrollableDiv"
              className="scrollable tl-scroll task-tb-scroll mytask-scroll"
            >
              <InfiniteScroll
                dataLength={this.state.helperTask.length}
                next={this.fetchData.bind(this)}
                hasMore={this.state.hasMore}
                loader={
                  this.state.isScrolling ? (
                    <Loader
                      styles={{
                        width: "80px",
                        margin: "auto",
                      }}
                      root={{ display: "flex" }}
                    />
                  ) : (
                    ""
                  )
                }
                scrollableTarget="scrollableDiv"
                endMessage={
                  this.state.helperTask.length === 0 ? (
                    <p className="loading-end" style={{ textAlign: "center" }}>
                      <b>No Data Found</b>
                    </p>
                  ) : (
                    <p className="loading-end">
                      <b>Yay! You have seen it all</b>
                    </p>
                  )
                }
              >
                {this.state.isLoading ? (
                  <Loader
                    styles={{ width: "50px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                ) : this.state.pageInfo.length + this.state.pageInfo.length ===
                  0 ? (
                  <EmptyLoader message="No Data found" />
                ) : (
                  <div className="tab-content task-tabs ">
                    <div id="waiting" className="tab-pane fade in active">
                      <div className="table-responsive tt-block">
                        <table className="table table-task">
                          <thead>
                            <tr>
                              <th style={{width: '50px' }}></th>
                              <th>Skill Name</th>
                              <th style={{width: '100px'}}>Status</th>
                              <th style={{ width: '200px'}}>Created by</th>
                              <th style={{ width: '350px'}}>Category</th>
                              <th></th>
                            </tr>
                          </thead>

                          <tbody>
                            {helperTask.map((task, i) =>
                              task.status == "pending" ? (
                                <tr key={i}>
                                  <td className="mt-checkbox">
                                    <input
                                      name={task.id}
                                      onClick={(e) => this.handleCheck(e, task)}
                                      type="checkbox"
                                    />
                                  </td>
                                  
                                  <td title={task?.SKILL_DESCRIPTION}>
                                    {task.SKILL_NAME}
                                  </td>
                                  <td>
                                    <span className="label label-warning label-pending">
                                      {task.status}
                                    </span>
                                  </td>
                                  <td>
                                    <div className="email-user">
                                      {/* <Tooltip title={task.USER_EMAIL}>
                                      <div className="em-icon">
                                        <span>
                                          {task.USER_EMAIL &&
                                            task.USER_EMAIL.slice(0, 2)}
                                        </span>
                                      </div>
                                      </Tooltip> */}
                                      <p title={task.USER_EMAIL}>
                                        {task.USER_EMAIL}
                                      </p>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="catg-box">
                                      <select
                                        id={`category-${task.id}`}
                                        className="form-control"
                                        value={this.state.selectedValues[task.id]?.category || task.CATEGORY || ""}
                                        onChange={(e) => this.handleCategoryChange(e, task.id)}
                                      >
                                        <option value="">Select Category</option>
                                        {Object.keys(this.state.categories).map((category) => (
                                          <option key={category} value={category}>
                                            {category}
                                          </option>
                                        ))}
                                      </select>
                                    
                                    {(this.state.selectedValues[task.id]?.category || task.CATEGORY) && (
                                        <select
                                          id={`subcategory-${task.id}`}
                                          className="form-control"
                                          value={this.state.selectedValues[task.id]?.subcategory || task.subCategory || ""}
                                          onChange={(e) => this.handleSubcategoryChange(e, task.id)}
                                        >
                                          <option value="">Select Subcategory</option>
                                          {this.state.categories[this.state.selectedValues[task.id]?.category || task.CATEGORY]?.map((subcat) => (
                                            <option key={subcat} value={subcat}>
                                              {subcat}
                                            </option>
                                          ))}
                                        </select>
                                      )}
                                    </div>
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                   
                                  </td>
                                </tr>
                              ) : null
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {/* )} */}
                  </div>
                )}
              </InfiniteScroll>
            </div>
          </div>
          <div className="modal fade qa-modal" id="mytaskModal1" role="dialog">
            <div className="modal-dialog">
              <div className="modal-content">
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
                <div className="modal-body md-edit">
                  <h4>Title / Question:</h4>
                  <p>
                    {this.state.popUpQuestion
                      ? this.state.popUpQuestion.question
                      : null}
                  </p>
                  <hr />
                  <h4>Alternate Questions:</h4>
                  {this.state.popUpQuestion &&
                    this.state.popUpQuestion.alter_questions.length ? (
                    <div>
                      {this.state.popUpQuestion.alter_questions.map((ques) => {
                        return <p>{ques.data}</p>;
                      })}
                    </div>
                  ) : null}
                </div>
                <div class="frm-btns fb-right">
                  <button class="btn-primary" data-dismiss="modal">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.userReducer,
  skill: state.skillReducer,
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    notify,
    getHelperTask,
    approveDraftSkill,
    getSession,
    executeFlow,
    updateDraftSkill,
    getDraftSkillsById,
    updateFormatedData,
  })
)(ApproveHelper);
